import clsx from "~/forms/utils/clsx";
import { CenterLayout as CenterLayoutCN } from './center-layout.css';
import * as CSS from './center-layout.css';

export default p => <div class={clsx(CenterLayoutCN, CSS[p.type], p.class)}>{p.children}</div>;